import { Link } from "react-router-dom";
import about from "./img/abtn.png";
import profile from "./img/mobile.png";
import icon07 from "./img/icon/icon-07-primary.png";
import icon06 from "./img/icon/icon-06-primary.png";
import icon03 from "./img/icon/icon-03-primary.png";
import icon04 from "./img/icon/icon-04-primary.png";
import icon10light from "./img/icon/icon-10-light.png";
import icon01light from "./img/icon/icon-01-light.png";
import icon06light from "./img/icon/icon-06-light.png";
import icon05light from "./img/icon/icon-05-light.png";
import icon08light from "./img/icon/icon-08-light.png";
import icon07light from "./img/icon/icon-07-light.png";
import Teamwork from "./img/icon/Teamwork.png";
import Integrity from "./img/icon/Integrity.png";
import Innovation from "./img/icon/Innovation.png";
import CustomerFocus from "./img/icon/CustomerFocus.png";

const ABOUT_PAGE_FACTS_VALUES = [
  { title: "Integrity", icon: Integrity, delay: "0.1s" },
  { title: "Customer Focus", icon: CustomerFocus, delay: "0.2s" },
  { title: "Innovation", icon: Innovation, delay: "0.3s" },
  { title: "Teamwork", icon: Teamwork, delay: "0.4s" },
];

function About() {
  window.scrollTo(0, 0);
  return (
    <main className="about-page">
      <div
        className="container-fluid page-header py-4 py-md-5 mb-4 mb-md-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-4 py-md-5">
          <h1 className="display-5 display-md-4 animated slideInDown mb-0 text-break">
            About Us
          </h1>
        </div>
      </div>
      {/* <!-- About Start --> */}
      <section
        className="container-xxl py-4 py-lg-5"
        aria-labelledby="about-page-intro-title"
      >
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="position-relative overflow-hidden rounded ps-3 pt-3 ps-md-5 pt-md-5 h-100 home-about-visual">
                <img
                  className="w-100 h-100"
                  src={about}
                  alt="About Ebix Insurance"
                  style={{ objectFit: "cover" }}
                  loading="lazy"
                />
                <div className="position-absolute top-0 start-0 bg-white rounded pe-2 pb-2 home-about-badge-wrap">
                  <div className="d-flex flex-column justify-content-center text-center bg-primary rounded h-100 p-2 p-md-3">
                    <h1 className="text-white mb-0 fs-2 fs-md-1">25</h1>
                    <h2 className="text-white fs-6 fs-md-5 mb-0">Years</h2>
                    <h5 className="text-white mb-0 small fs-6 fs-md-5">
                      Experience
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="h-100">
                <p className="home-eyebrow text-primary fw-semibold text-uppercase mb-2">
                  About us
                </p>
                <h2
                  id="about-page-intro-title"
                  className="display-6 mb-3 mb-md-4 text-break"
                >
                  We're Here To Assist You With Exploring Protection
                </h2>
                <p className="fs-6 fs-md-5 text-primary mb-4">
                  Our commitment to expertise, comprehensive coverage, and
                  personalized service sets us apart as a trusted partner for
                  our clients
                </p>
                <div className="row g-4 mb-4">
                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <img className="flex-shrink-0 me-3" src={icon04} alt="Flexible Insurance icon" loading="lazy" />
                      <h5 className="mb-0">Flexible Insurance Plans</h5>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <img className="flex-shrink-0 me-3" src={icon03} alt="Money Back Guarantee icon" loading="lazy" />
                      <h5 className="mb-0">Money Back Guarantee</h5>
                    </div>
                  </div>
                </div>
                <p className="mb-4">
                  Our mission is to be the most trusted and respected insurance
                  broking company in the industry, known for our exceptional
                  service, expertise, and commitment to our clients.
                </p>
                <div className="border-top mt-4 pt-4">
                  <div className="d-flex flex-wrap align-items-center gap-2 gap-md-3">
                    <img
                      className="flex-shrink-0 rounded-circle me-md-1"
                      src={profile}
                      alt="Company profile"
                      loading="lazy"
                    />
                    <h5 className="mb-0 fs-6 fs-md-5 text-break">
                      Call Us: +91 8433720891
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- About End --> */}

      {/* <!-- Facts Start --> */}
      <section
        className="home-facts-section"
        aria-labelledby="about-facts-vision-title"
      >
        <div className="container-fluid overflow-hidden my-4 my-md-5 px-lg-0">
          <div className="container facts px-lg-0">
            <div className="row g-0 gx-0 gy-4 gy-lg-0 mx-lg-0 align-items-stretch">
              <div
                className="col-lg-6 facts-text wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div className="h-100 px-4 px-md-5 ps-lg-0 d-flex flex-column justify-content-center">
                  <p className="home-eyebrow text-white text-opacity-90 fw-semibold text-uppercase mb-2 mb-md-3">
                    Insure Karo, Secure Raho
                  </p>
                  <h2
                    id="about-facts-vision-title"
                    className="text-white mb-3 mb-md-4 fs-2 fs-md-3"
                  >
                    Our Vision
                  </h2>
                  <p className="text-light mb-4 mb-md-5 small fs-5 fs-md-5">
                    We make insurance easier to understand and access through
                    clear guidance and dependable service. As your broker, we
                    help you choose coverage that fits your needs—keeping the
                    process straightforward, transparent, and focused on
                    protecting what matters most.
                  </p>
                  <Link
                    to="/contactus"
                    className="btn btn-secondary py-3 px-4 px-md-5 w-md-auto align-self-md-center"
                  >
                    Contact us
                  </Link>
                </div>
              </div>
              <div
                className="col-lg-6 facts-counter wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div className="h-100 px-4 px-md-5 ps-lg-0 d-flex flex-column justify-content-center">
                  <h2
                    id="about-facts-values-title"
                    className="text-dark mb-3 mb-md-4 fs-2 fs-md-3"
                  >
                    Our Values
                  </h2>
                  <div className="row g-3">
                    {ABOUT_PAGE_FACTS_VALUES.map(({ title, icon, delay }) => (
                      <div
                        key={title}
                        className="col-sm-6 home-facts-value-tile wow fadeIn"
                        data-wow-delay={delay}
                      >
                        <div className="bg-light rounded-3 h-100 p-2 p-sm-3 shadow-sm">
                          <div className="bg-white border border-light rounded-3 d-flex flex-column justify-content-center align-items-center text-center h-100 py-4 px-3">
                            <img
                              className="mb-3 home-facts-value-icon"
                              src={icon}
                              alt={title}
                              loading="lazy"
                            />
                            <h3 className="mb-0 fs-6 fs-md-5 fw-semibold">
                              {title}
                            </h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Facts End --> */}
    </main>
  );
}
export default About;
